// src/services/authService.ts
import axios from "axios";

const API_URL = "https://portfoliom-backend.vercel.app/auth";

const getToken = () => localStorage.getItem("token");

export const deleteUser = async (id: number) => {
    try {
        const token = getToken();
        const res = await axios.delete(`${API_URL}/users/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return res.data; // { success: boolean, message: string }
    } catch (err: any) {
        console.error(err);
        throw new Error(err.response?.data?.message || "Kullanıcı silinemedi");
    }
};
